export default "__VITE_ASSET__BP_6zPJl__"